import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

interface BackButtonProps {
  /** List route used when there is no history to go back to (direct load / new tab). */
  fallbackTo: string;
  label?: string;
  className?: string;
}

/**
 * Shared "back" affordance for detail pages.
 * Goes back in history when possible, otherwise navigates to the given list route.
 */
const BackButton: React.FC<BackButtonProps> = ({ fallbackTo, label = 'Quay lại', className }) => {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    const historyIndex = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (historyIndex > 0) {
      navigate(-1);
    } else {
      navigate(fallbackTo);
    }
  }, [navigate, fallbackTo]);

  return (
    <Button type="text" size="small" icon={<ArrowLeftOutlined />} onClick={handleBack} className={className}>
      {label}
    </Button>
  );
};

export default BackButton;
